import { TravelAgentLogo } from "components/layouts/Header/TravelAgentLogo";
import WhimstayContainerNew from "components/utilities/WhimstayContainerNew";
import About from "./About";
import CopyrightDetails from "./CopyrightDetails";
import Destinations from "./Destinations";
import SpacerForDetailPage from "./SpacerForDetailPage";
const Footer = () => {
  return <footer className='bg-primary-500' data-nosnippet data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
      <WhimstayContainerNew className='flex flex-col px-6 pb-6 pt-10 md:px-12 md:pt-12 lg:px-0' data-sentry-element="WhimstayContainerNew" data-sentry-source-file="Footer.tsx">
        <div className='pb-6'>
          <div className='mb-8 shrink-0'>
            <TravelAgentLogo className='text-white' data-sentry-element="TravelAgentLogo" data-sentry-source-file="Footer.tsx" />
          </div>
          <div className='flex flex-col gap-10 lg:grid lg:grid-cols-[220px_minmax(0,1fr)] lg:items-start lg:gap-x-[72px] lg:gap-y-0'>
            <About data-sentry-element="About" data-sentry-source-file="Footer.tsx" />
            <Destinations data-sentry-element="Destinations" data-sentry-source-file="Footer.tsx" />
          </div>
        </div>

        <div className='h-px w-full bg-[rgba(248,248,248,0.2)]' />

        <CopyrightDetails data-sentry-element="CopyrightDetails" data-sentry-source-file="Footer.tsx" />

        <SpacerForDetailPage data-sentry-element="SpacerForDetailPage" data-sentry-source-file="Footer.tsx" />
      </WhimstayContainerNew>
    </footer>;
};
export default Footer;